//-------------------------------------------------------------------------
// RecentlyAddedProjectsController
//-------------------------------------------------------------------------
angular.module('EICDataStream3.projectDisplayModule')
  .controller("RecentlyAddedProjectsController", ['ENUMS', '$scope', '$state', '$location', 'recentlyAddedProjectsSummaryDataService', 'searchService',
    'lookupTables', 'reportRequestService', 'dialogService', 'summaryDownloadService', 'geographicalProjectPresenterService',
    'exportRequestService', 'FEATURE_SWITCHES',
    function (ENUMS, $scope, $state, $location, recentlyAddedProjectsSummaryDataService, searchService,
      lookupTables, reportRequestService, dialogService, summaryDownloadService, geographicalProjectPresenterService,
      exportRequestService, FEATURE_SWITCHES) {
      $scope.componentName = "RecentlyAddedProjectsController";

      $scope.NEW_EXPORTS = FEATURE_SWITCHES.NEW_EXPORTS;

      $scope.title = 'Recently Added Projects';

      $scope.recentlyAddedProjectsSummaryDataService = recentlyAddedProjectsSummaryDataService;
      $scope.dataFlowControl = recentlyAddedProjectsSummaryDataService.dataFlowControl;
      $scope.criteria =  searchService.queryDef.criteria;

      $scope.industrySectors = lookupTables.industrySectors();

      var refreshList = function(){
        if ($scope.criteria.selectedIndustrySectorIDs.length > 0 && $scope.criteria.createdWithinWeeks > 0)
          recentlyAddedProjectsSummaryDataService.search($scope.criteria.createdWithinWeeks);
      };


      $scope.$watch("criteria.selectedIndustrySectors", function (newlist, oldlist) {
        // translate selected IndustrySectors to selected Industry Sector IDs ||  !oldlist
        if (!$scope.criteria.selectedIndustrySectors || !$scope.criteria.createdWithinWeeks) return;

        $scope.criteria.selectedIndustrySectorIDs = $scope.criteria.selectedIndustrySectors.map(function(item){
          return item.id;
        });

        refreshList();


        $scope.industrySectorPlural = ($scope.industrySectorSelectedCount === 1) ? "" : "s";
        if ($scope.criteria.selectedIndustrySectors.length === $scope.industrySectors.length) {
          $scope.industrySectorSelectedCount = "all";
        } else {
          $scope.industrySectorSelectedCount = $scope.criteria.selectedIndustrySectors.length;
        }

      });


      $scope.$watch("criteria.createdWithinWeeks", function(newlist, oldlist) {
        // translate selected IndustrySectors to selected Industry Sector IDs
        if (!$scope.criteria.selectedIndustrySectors || !$scope.criteria.createdWithinWeeks ) return;

        refreshList();
      });


      $scope.exportSummary = function () {
        return summaryDownloadService.recentlyAddedProjects($scope.criteria.createdWithinWeeks);
      };

      $scope.areAnyProjectsChecked = function() {
        return ($scope.projectSelectionSummary.numberOfProjectsSelected>0);
      }

      // this structure is passes into the Projects display directive.
      // // it allows values to be passed out again, as well as pre and post
      // // selection special actions
      $scope.projectSelectionSummary = {
        projectSelecting:function(projectID, isChecked){},
        projectSelected:function(projectID, isChecked){},

        numberOfProjectsSelected:0,
        areAnyProjectsSelected:false,
        areAllProjectsSelected:false
      };

      //////////////////////////////////////////////////////////////////////
      ////  Open dialog for selected project(s) watch
      //////////////////////////////////////////////////////////////////////
      $scope.openSelectedProjectWatchDialog = function () {
        dialogService.openSelectedProjectWatchDialog(ENUMS.PROJECT_WATCH_CREATE_REASONS.RECENTLY_ADDED_PROJECTS);
      };


      $scope.actionMenu = {
        items: [
          // {
          //   text: "Export Summary",
          //   actionType: "function",
          //   action: $scope.exportSummary,
          //   visible: function () {
          //     return !$scope.NEW_EXPORTS.PROJECT_EXPORT_ENABLED;
          //   },
          //   disabled: $scope.areAnyProjectsChecked
          // },
          {
            text: "Export Summary...",
            actionType: "function",
            action: exportRequestService.openProjectExportRequestDialog,
            visible: function () {
              // return true;
              return $scope.NEW_EXPORTS.PROJECT_EXPORT_ENABLED && !$scope.NEW_EXPORTS.SUSPENDED;
            },
            disabled: function () { return false }
          },
          {
            text: "Export Service Suspended",
            actionType: "function",
            action: function () { },
            visible: function () {
              return $scope.NEW_EXPORTS.SUSPENDED;
            },
            disabled: function () { return true }
          },
          //{
          //  text: "Share...",
          //  actionType: "href",
          //  action: $scope.share,
          //  visible: function() { return true;},
          //  disabled: $scope.areAnyProjectsChecked
          //},
          {
            text: "PDF Service Suspended",
            actionType: "function",
            action: function () { },
            visible: function () {
              return $scope.areAnyProjectsChecked() && $scope.NEW_REPORT_REQUEST.SUSPENDED;
            },
            disabled: function () { return true }
          },
          {
            text: "PDF of selected projects...",
            actionType: "function",
            action: reportRequestService.openReportRequestDialog_selectedProjects,
            visible: function () {
              return $scope.areAnyProjectsChecked() && !$scope.NEW_REPORT_REQUEST.SUSPENDED;
            },
            disabled: function () { return false }
          },
          {
            text: "Watch selected projects...",
            actionType: "function",
            action: $scope.openSelectedProjectWatchDialog,
            visible: function() { return $scope.areAnyProjectsChecked(); },
            disabled: function () { return false }
          },
          {
            isDivider: true,
            visible: function () {
              return FEATURE_SWITCHES.GEOGRAPHICAL_PROJECT_PRESENTER.enabled;
            }
          },
          {
            text: "Show selected projects on a map... (Beta)",
            actionType: "function",
            action: geographicalProjectPresenterService.post_selectedProjects,
            visible: function () {
              return FEATURE_SWITCHES.GEOGRAPHICAL_PROJECT_PRESENTER.enabled; 
            },
            disabled: function() { return !$scope.areAnyProjectsChecked(); }
          }
        ]
      };


      $scope.$on("SORT_CHANGED", function (event, sort) {
        recentlyAddedProjectsSummaryDataService.sort(sort);
      });

      $scope.$watch('criteria.createdWithinWeeks', function(newVal){
        if(!newVal) return;

        // when the created withinWeeks value changes, update the querystring
        // so that stateParams will be able to follow up when returning to the page
       $location.search('createdwithinweeks', newVal);

      });

      $scope.$on('$viewContentLoaded', function () {
        var weeks  = parseInt($state.params.createdwithinweeks,10) || 2;
        weeks = Math.min(weeks, 12);
        $scope.criteria.createdWithinWeeks = weeks;

        //var createdSince = new Date($state.params.createdsince);
        //
        //if (createdSince.getTime() !== createdSince.getTime()){
        //  // an invalid date will give NaN for getTime and
        //  // the cpomparision will be trua as NaN is not equal to itself
        //  createdSince = new Date()
        //  createdSince.setDate(createdSince.getDate() - 14); // subtract 2 weeks
        //  createdSince.setTime(0);
        //}
        //
        //$scope.createdSince = createdSince;


      });

 
    }
  ]);


